export const lang = require('../../assets/lang/en').default